/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseOrderSearchResult } from '../../models/purchase-order-search-result';

export interface GetPurchaseOrders$Params {
  page: number;
  size: number;
}

export function getPurchaseOrders(http: HttpClient, rootUrl: string, params: GetPurchaseOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrderSearchResult>> {
  const rb = new RequestBuilder(rootUrl, getPurchaseOrders.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchaseOrderSearchResult>;
    })
  );
}

getPurchaseOrders.PATH = '/purchase-orders';
